<div class="view-toggle">
    <button class="toggle-btn" [class.active]="viewMode === 'table'" (click)="setMode('table')"
      [title]="translationService.instant('common.tableView', 'Table View')">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
      </svg>
      <span>{{ translationService.instant('common.table', 'Table') }}</span>
    </button>
    <button class="toggle-btn" [class.active]="viewMode === 'card'" (click)="setMode('card')"
      [title]="translationService.instant('common.cardView', 'List View')">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
      </svg>
      <span>{{ translationService.instant('common.list', 'List') }}</span>
    </button>
  </div>
